import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { getAxiosResponse, putOrPostAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { dateConvertToTimeStamp, transformBlankToNull } from '../../../services/Util';
import Constants from "../../../Constants";
import jQuery from "jquery";
import ExactTargetCredential from "./ExactTargetCredential";
import UserPermissionsSetting from "./UserPermissionsSetting"
import BackToSetting from "../BackToSetting"
import { RotatingLines } from "react-loader-spinner";
import SuccessMessage from "../../../components/SuccessMessage";
import { useNavigate } from "react-router-dom";
import { getLoggedInUserRole } from "../../../services/Util";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import $ from "jquery";
import { logError } from "../../../services/authApiRoutes/APImethods";
import { handleError } from "../../../services/authApiRoutes/APImethods";

export default function ExactTargetIntegrationSetting () {
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const theme = aaaSelected ? "dark" : "";
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();

  const ExactTargetCredentialMemo = React.memo(ExactTargetCredential);
  const UserPermissionsSettingMemo = React.memo(UserPermissionsSetting);
  const [permissionStatus,setPermissionStatus]=useState(false)

  const [integrationUsers, setIntegrationUsers] = useState([]);
  const [pendingPermission, setPendingPermission] = useState(false);
  const [conditionalpopup, setconditionalpopup] = useState(false);
  const [credentialData, setCredentialData] = useState({});
  const [serverErrorMessage, setServerErrorMessage] = useState([]);
  const [isValidating, setValidating] = useState(false);
  const [successMessage, setSuccessMessage] = useState();
  const [rule, setRule] = useState();
  const [user, setUser] = useState();
  const roleArray = getLoggedInUserRole();

  const showModel = () => {
    document.body.classList.add("modal-open");
  };
  const hideModel = () => {
    document.body.classList.remove("modal-open");
  };
  const showEditModel = (setting) => {
    setconditionalpopup(false);
    setServerErrorMessage([]);
    setSuccessMessage("");
    document.body.classList.add("modal-open");
  };
  const hideEditModel = () => {
    setSuccessMessage("");
    document.body.classList.remove("modal-open");
  };

  useEffect(()=>{
    $(".lastdisable").trigger("focus");
  }, [])

  const deptSettingsColumns = [
    {
      id: "setting.name",
      name: "Department",
      maxWidth: "350px",
      selector: (setting) => setting.userGroup,
      sortable: true,
      cell: (setting) => setting.userGroup.name
    },
    {
      id: "setting.credentials",
      name: "System User Credentials",
      maxWidth: "350px",
      selector: (setting) => setting.name,
      center: true,
      cell: (setting) => (
        <div className="flex-center">
          <button className="inline-flex ml-10" aria-label="edit" onClick={() => showEditModel(setting)}>
            <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
              <path d="M4.65122 14.1491H0.817969V10.3143L10.5199 0.642481L10.52 0.642316C10.8375 0.324878 11.2595 0.15 11.7092 0.15C12.1589 0.15 12.5809 0.324838 12.8993 0.643233L14.3532 2.09707C14.6715 2.41546 14.8464 2.83748 14.8464 3.28717C14.8464 3.73685 14.6715 4.15887 14.3532 4.47727L4.65122 14.1491ZM11.8152 1.7272L11.7093 1.62143L11.6033 1.7271L10.1467 3.1791L10.0403 3.2852L10.1466 3.39143L11.6004 4.84435L11.7063 4.95015L11.8123 4.84452L13.2698 3.39252L13.3764 3.28638L13.27 3.18012L11.8152 1.7272ZM2.3513 12.4657V12.6157H2.5013H3.95605H4.01805L4.06195 12.572L10.5144 6.13973L10.6208 6.03367L10.5145 5.92743L9.0607 4.4736L8.9548 4.3677L8.84873 4.47343L2.3954 10.9066L2.3513 10.9506V11.0128V12.4657ZM0.817969 16.2824H15.1846V17.8157H0.817969V16.2824Z" fill="#1D4ED8" stroke="#F1F5FF" strokeWidth="0.3"/>
            </svg>
          </button>
        </div>
      )
    }
  ];

  useEffect(() => {
    getIntegrationusers();
    getUser();
    //getCredential();
    getRules();
  }, [])

  useEffect(() => {
    if (user?.permissions[Constants.EXACTTARGET_ACCESS] === true) {
      getCredential();
    }
  }, [user])

  useEffect(()=>{
    if(successMessage!==Constants.BLANK){
      setSuccessMessage(successMessage);
      setTimeout(function(){
        setSuccessMessage(Constants.BLANK);
      },5000);
    }
  },[successMessage]);

  const close = () => {
    navigate("/settings")        
  }

  const validateCredential = () => {
    setSuccessMessage("Validating credentials...")
    setValidating(true);
    var isPost = true;

    credentialData.credentials = {
      'CLIENT_ID': jQuery("#exacttarget-client-id-input").val(),
      'CLIENT_SECRET': jQuery("#exacttarget-client-secret-input").val(),
      'SUB_DOMAIN': jQuery("#exacttarget-sub-domain-input").val()
    };
    credentialData.credentialsType = "EXACTTARGET"
    if(credentialData?.id){
      isPost = false;
    }
    putOrPostAxiosResponse(APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(Constants.EXACTTARGET), credentialData, isPost
      ).then((res) => {
        setValidating(false);
        setSuccessMessage(Constants.BLANK)
        if (res.data?.handledMessage || res.data?.data?.handledMessage){
          setServerErrorMessage([res.data.handledMessage])
        } else {
          setServerErrorMessage([]);
          setSuccessMessage("ExactTarget API Settings successfully validated")
        }
      }).catch((err) => {
        setValidating(false);
        const errorMessage = "err - ";
        logError(errorMessage, err); 
        setSuccessMessage(Constants.BLANK)
      })
  }

  const getUser = () => {    
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.FULL_USER + `?_=${dateTimestamp}`
		).then(res => {
      if (res.data.code === 200) {
			  let user = transformBlankToNull(res.data.data);
        setUser(user)
      }
		})
  }

  const getIntegrationusers = () => {
    setPendingPermission(true);
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.CUSTOMER_INTEGRATION_USERS + `?_=${dateTimestamp}`
    ).then((res) => {
      setPendingPermission(false);
      if (res.data.code === 200) {
        let integrationUsers = transformBlankToNull(res.data.data);
        setIntegrationUsers(integrationUsers);
      }
    }).catch((err) => {
      handleError(err);
    });
  }

  const getCredential = () => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(Constants.EXACTTARGET) + `?_=${dateTimestamp}`
    ).then (res => {
      if (res.data.code === 200) {
        var credentialsSet = transformBlankToNull(res.data.data.body)
        setCredentialData(credentialsSet)
      }
    }).catch(err => {
      handleError(err);
    });   
  };

  const getRules = () => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.EXACTTARGET_DATA_EXTENSIONS_DEFAULT + `?_=${dateTimestamp}`
    ).then(res => {
      if (res.data.code === 200) {
        var rule = transformBlankToNull(res.data.data)
        setRule(rule)
      }
    }).catch(err => {
      handleError(err);
    });   
  };

  const saveRule = () => {
    setSuccessMessage("Updating rule.")
    setValidating(true);
    let isPost = true;
    if (rule?.id) {
      isPost = false;
    }
    rule.name = jQuery("#exacttarget-lang-column-input").val();
      putOrPostAxiosResponse(APIUrls.EXACTTARGET_DATA_EXTENSIONS_DEFAULT, rule, isPost
      ).then(res => {
        setValidating(false);
        if (res.data.code === 200) {
          setSuccessMessage("Rule updated sucessfully.")
          var rule = transformBlankToNull(res.data.data)
          setRule(rule)
        }
      }).catch(err => {
        setSuccessMessage(Constants.BLANK);
        handleError(err);
        setValidating(false);
      });

  }

  const clopseExpandAccordion = (accordion) => {
    if (accordion.hasClass("open")) {
      accordion.removeClass("open")
    } else {
      accordion.addClass("open")
    }
  }
  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'ExactTarget Integration', url:''}
  ];
  return (
    <>
    <div className={isValidating ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
        <RotatingLines strokeColor="#0096FF" strokeWidth="5" width="196" visible={true} />
      </div>
    </div> 
    {(successMessage!==undefined && successMessage !== Constants.BLANK)?<SuccessMessage message={successMessage}/>:Constants.BLANK}

    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} >
          <div id="content" className="dashboard-wrap">
             <Breadcrumb crumbs={ crumbs } />
             <div className="project-setting-page">
                <div className="project-heading userprofile-heading">
                    <BackToSetting />
                    <h3 className="flex">ExactTarget Integration</h3>
                    <span>Browse and send your ExactTarget multilingual emails to translation.</span>
                 </div>
                <div className="white-bg"> 
                <div className="integration-tab-content marketo-integration-accordion">
                {roleArray.includes ("ROLE_CUSTOMER")  ? (
                    <div id="permission-accordion" className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Permission to Use the ExactTarget Integration</strong>
                        </div>
                        <div className="right" onClick={() => clopseExpandAccordion(jQuery("#permission-accordion"))}>
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                       <p>Manage who has permission to create ExactTarget integration projects in OPAL-Marketing. Users can set up their ExactTarget credentials in the "Integration" subtab of the My Account page.</p>
                       <div className="datatable-block custom_pagination">
                       <UserPermissionsSettingMemo 
                          settingType = {Constants.EXACTTARGET}
                          accessName = "Access to ExactTarget"
                          integrationUsers={integrationUsers}
                          pendingPermission={pendingPermission}
                          getUser={getUser}
                          setPermissionStatus={setPermissionStatus}
                        />
                        </div>
                      </div>
                    </div>
                    ) : null}
                    <div id="data-ext-accordion" className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Data Extensions</strong>
                        </div>
                        <div className="right" onClick={() => clopseExpandAccordion(jQuery("#data-ext-accordion"))}>
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                       <p>The default language column needs to be saved for future use in data extension project creation.</p>
                       <div className="datatable-block custom_pagination">
                       <div className="global-dropdown-block mr-0">
                        <label>Name of Language Column</label>
                          <div className="global-dropdown-select">
                            <input id="exacttarget-lang-column-input" type="text" className="form-control-sm" placeholder="Sub Domain" defaultValue={rule?.name} />                            
                          </div>
                          <div className="flex flex-end mar-top20">
                            <button id="save-rule" className="blue-btn active" onClick={() => saveRule()}>Save</button>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>

                    {user?.permissions[Constants.EXACTTARGET_ACCESS] === true && 
                    <div id="integration-accordion" className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>ExactTarget API Settings</strong>
                        </div>
                        <div className="right" onClick={() => clopseExpandAccordion(jQuery("#integration-accordion"))}>
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                         <p className="f14-para">Manage your ExactTarget login credentials for ExactTarget Integration projects.</p>
                          <p>OPAL-Marketing accelerates and automates the localization process by integrating directly with ExactTarget. 
                            The content can subsequently be translated into the desired languages and an in-context review can take 
                            place allowing reviewers to edit and comment on the content. After the translations have been approved, 
                            OPAL-Marketing automatically updates ExactTarget with the translated emails.</p>
                              <ExactTargetCredentialMemo 
                                credentialData = {credentialData} 
                                errorMessages = {serverErrorMessage}
                                isValidating = {isValidating}
                                successMessage = {successMessage} 
                                closePopup = {hideEditModel}
                              />
                          <div className="flex flex-end mar-top20">
                            <button id="validate-credential" className="blue-btn active" onClick={() => validateCredential()}>Validate</button>
                          </div>
                      </div>
                    </div>
                    }
                  </div> 
                </div>
             </div>
          </div>
        </section>
      </div>
      
      {conditionalpopup ? 
         <div className="lightbox-panel target-lang-popup">
            <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
              <strong>Departments</strong>
              <button className="close" aria-label="close right popup" onClick={hideModel}>
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path>
                <path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path>
              </svg>
             </button>
             </div>
             <div className="lightbox-content">
               <div className="gb-gray-list">
                  <ul>
                    <li>Anurag V Test Department</li>
                    <li>Anurag V Test Department</li>
                    <li>Marketing-NewDeptt</li>
                    <li>Anurag V Test Department</li>
                    <li>Depart_1</li>
                    <li>Marketing-NewDeptt</li>
                    <li>DDepartment-4</li>
                    <li>Anurag V Test Department</li>
                    <li>Anurag V Test Department</li>
                    <li>Anurag V Test Department</li>
                    <li>Anurag V Test Department</li>
                    <li>Marketing-NewDeptt</li>
                    <li>Anurag V Test Department</li>
                    <li>Depart_1</li>
                    <li>Marketing-NewDeptt</li>
                  </ul>
               </div>
             </div>	
            
            </div>		
          </div>
          :
          ("")
        }
        <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
            {/* <div>
             <button className="btn-default">Cancel</button>
            </div> */}
            <div>
            <button id="savecredential" className="btn-default Active" onClick={() => close()}>Close</button>
            </div>
        </div>
      </div> 
    </div>
    </>
  );
}
